import React, { createContext, useContext, useReducer, useCallback } from 'react';
import { generateId } from '../utils/helpers';

// ─── Initial Data ────────────────────────────────────────────────────────────
const initialProspects = [
  { id: '1', nama: 'Budi Santoso', noHP: '081234567890', alamat: 'Jl. Merdeka No.1, Jakarta', mobilDiminati: 'Honda Brio', sumberLead: 'Walk-in', status: 'Hot', createdAt: '2024-01-15', salesId: '1' },
  { id: '2', nama: 'Siti Rahayu', noHP: '082345678901', alamat: 'Jl. Sudirman No.5, Bandung', mobilDiminati: 'Honda HR-V', sumberLead: 'Instagram', status: 'Warm', createdAt: '2024-01-16', salesId: '2' },
  { id: '3', nama: 'Ahmad Fauzi', noHP: '083456789012', alamat: 'Jl. Gatot Subroto No.10, Surabaya', mobilDiminati: 'Honda CR-V', sumberLead: 'Referral', status: 'Cold', createdAt: '2024-01-17', salesId: '1' },
  { id: '4', nama: 'Dewi Kusuma', noHP: '084567890123', alamat: 'Jl. Ahmad Yani No.3, Medan', mobilDiminati: 'Honda Jazz', sumberLead: 'Facebook', status: 'Hot', createdAt: '2024-01-18', salesId: '3' },
  { id: '5', nama: 'Rizki Pratama', noHP: '085678901234', alamat: 'Jl. Diponegoro No.7, Yogyakarta', mobilDiminati: 'Honda WR-V', sumberLead: 'Walk-in', status: 'Warm', createdAt: '2024-01-19', salesId: '2' },
];

const initialSPK = [
  { id: '1', spkNumber: 'SPK-2024-001', namaPembeli: 'Budi Santoso', tipeMobil: 'Honda Brio S MT', harga: 165000000, dp: 33000000, metodePembayaran: 'Kredit', tenor: 48, status: 'Proses', createdAt: '2024-01-20', salesId: '1' },
  { id: '2', spkNumber: 'SPK-2024-002', namaPembeli: 'Dewi Kusuma', tipeMobil: 'Honda Jazz RS CVT', harga: 285000000, dp: 57000000, metodePembayaran: 'Kredit', tenor: 36, status: 'Selesai', createdAt: '2024-01-21', salesId: '3' },
  { id: '3', spkNumber: 'SPK-2024-003', namaPembeli: 'Hendra Wijaya', tipeMobil: 'Honda HR-V 1.5 SE', harga: 380000000, dp: 380000000, metodePembayaran: 'Cash', tenor: 0, status: 'Selesai', createdAt: '2024-01-22', salesId: '2' },
];

const initialDelivery = [
  { id: '1', namaPembeli: 'Budi Santoso', tipeMobil: 'Honda Brio S MT', tanggalKirim: '2024-02-01', statusPengiriman: 'Proses', noPolisi: 'B 1234 ABC', createdAt: '2024-01-28' },
  { id: '2', namaPembeli: 'Dewi Kusuma', tipeMobil: 'Honda Jazz RS CVT', tanggalKirim: '2024-01-30', statusPengiriman: 'Terkirim', noPolisi: 'B 5678 DEF', createdAt: '2024-01-25' },
  { id: '3', namaPembeli: 'Hendra Wijaya', tipeMobil: 'Honda HR-V 1.5 SE', tanggalKirim: '2024-01-28', statusPengiriman: 'Terkirim', noPolisi: 'B 9012 GHI', createdAt: '2024-01-23' },
];

const initialTeam = [
  { id: '1', nama: 'Andi Prasetyo', role: 'Sales Executive', email: 'andi@honda.co.id', noHP: '081111111111', cabang: 'Jakarta Pusat', status: 'active', target: 10, pencapaian: 8 },
  { id: '2', nama: 'Rina Sari', role: 'Sales Executive', email: 'rina@honda.co.id', noHP: '082222222222', cabang: 'Jakarta Selatan', status: 'active', target: 10, pencapaian: 10 },
  { id: '3', nama: 'Doni Kurniawan', role: 'Senior Sales', email: 'doni@honda.co.id', noHP: '083333333333', cabang: 'Jakarta Barat', status: 'active', target: 15, pencapaian: 12 },
  { id: '4', nama: 'Maya Indah', role: 'Sales Executive', email: 'maya@honda.co.id', noHP: '084444444444', cabang: 'Jakarta Timur', status: 'leave', target: 10, pencapaian: 5 },
];

const initialEvents = [
  { id: '1', title: 'Test Drive Honda Brio', date: '2024-02-05', time: '10:00', type: 'testdrive', customerId: '1' },
  { id: '2', title: 'Follow-up Siti Rahayu', date: '2024-02-06', time: '14:00', type: 'followup', customerId: '2' },
  { id: '3', title: 'Serah Terima Honda Jazz', date: '2024-02-08', time: '09:00', type: 'delivery', customerId: '4' },
];

const initialNotes = {};

const initialState = {
  prospects: initialProspects,
  spk: initialSPK,
  delivery: initialDelivery,
  team: initialTeam,
  events: initialEvents,
  notes: initialNotes,
  notification: null,
  settings: {
    cabang: 'Honda Authorized Dealer',
    kota: 'Jakarta',
    targetBulanan: 50,
    currency: 'IDR',
  },
};

// ─── Reducer ──────────────────────────────────────────────────────────────────
function reducer(state, action) {
  switch (action.type) {
    // Prospects
    case 'ADD_PROSPECT':
      return { ...state, prospects: [{ ...action.payload, id: generateId(), createdAt: new Date().toISOString().split('T')[0] }, ...state.prospects] };
    case 'UPDATE_PROSPECT':
      return { ...state, prospects: state.prospects.map(p => p.id === action.payload.id ? action.payload : p) };
    case 'DELETE_PROSPECT':
      return { ...state, prospects: state.prospects.filter(p => p.id !== action.payload) };

    // SPK
    case 'ADD_SPK':
      return { ...state, spk: [{ ...action.payload, id: generateId(), createdAt: new Date().toISOString().split('T')[0] }, ...state.spk] };
    case 'UPDATE_SPK':
      return { ...state, spk: state.spk.map(s => s.id === action.payload.id ? action.payload : s) };
    case 'DELETE_SPK':
      return { ...state, spk: state.spk.filter(s => s.id !== action.payload) };

    // Delivery
    case 'ADD_DELIVERY':
      return { ...state, delivery: [{ ...action.payload, id: generateId(), createdAt: new Date().toISOString().split('T')[0] }, ...state.delivery] };
    case 'UPDATE_DELIVERY':
      return { ...state, delivery: state.delivery.map(d => d.id === action.payload.id ? action.payload : d) };
    case 'DELETE_DELIVERY':
      return { ...state, delivery: state.delivery.filter(d => d.id !== action.payload) };

    // Team
    case 'ADD_TEAM_MEMBER':
      return { ...state, team: [...state.team, { ...action.payload, id: generateId() }] };
    case 'UPDATE_TEAM_MEMBER':
      return { ...state, team: state.team.map(t => t.id === action.payload.id ? action.payload : t) };
    case 'DELETE_TEAM_MEMBER':
      return { ...state, team: state.team.filter(t => t.id !== action.payload) };

    // Events
    case 'ADD_EVENT':
      return { ...state, events: [...state.events, { ...action.payload, id: generateId() }] };
    case 'DELETE_EVENT':
      return { ...state, events: state.events.filter(e => e.id !== action.payload) };

    // Notes
    case 'ADD_NOTE':
      return { ...state, notes: { ...state.notes, [action.payload.customerId]: [...(state.notes[action.payload.customerId] || []), { id: generateId(), text: action.payload.text, createdAt: new Date().toISOString() }] } };

    // Settings
    case 'UPDATE_SETTINGS':
      return { ...state, settings: { ...state.settings, ...action.payload } };

    // Notification
    case 'SHOW_NOTIFICATION':
      return { ...state, notification: action.payload };
    case 'HIDE_NOTIFICATION':
      return { ...state, notification: null };

    default:
      return state;
  }
}

// ─── Context ──────────────────────────────────────────────────────────────────
const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const showNotification = useCallback((message, type = 'success') => {
    dispatch({ type: 'SHOW_NOTIFICATION', payload: { message, type } });
    setTimeout(() => dispatch({ type: 'HIDE_NOTIFICATION' }), 3000);
  }, []);

  return (
    <AppContext.Provider value={{ state, dispatch, showNotification }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be used within AppProvider');
  return ctx;
}
